import {
  Card, Col,
  Row, Space,
  Typography
} from 'antd';
import { useTranslation } from 'react-i18next';

import { ApproveSalaryDataTypes } from 'common/services/extends/approveSalary/types';
import { formatDateDDMMYYYY } from 'common/utils/functions';

type InfoCardProps = {
  data?: ApproveSalaryDataTypes
};

const InfoCard: React.FC<InfoCardProps> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Card
      title={(
        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
          <Typography.Title level={4}>
            {t('program.info')}
          </Typography.Title>
        </Space>
      )}
    >
      <div className="site-card-border-less-wrapper">
        <Row gutter={16}>
          <Col className="u-mb-8" xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography.Text>
              {t('timesheet.codeProgram')}
            </Typography.Text>
            <Typography.Text strong>
              {data?.projectData?.code || ''}
            </Typography.Text>
          </Col>
          <Col className="u-mb-8" xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography.Text>
              {t('program.nameCustomer')}
              {' '}
            </Typography.Text>
            <Typography.Text strong>
              {data?.projectData?.customerName || ''}
            </Typography.Text>
          </Col>
          <Col className="u-mb-8" xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography.Text>
              {t('timesheet.nameProgram')}
              {' '}
            </Typography.Text>
            <Typography.Text strong>
              {data?.projectData?.name || ''}
            </Typography.Text>
          </Col>
          <Col className="u-mb-8" xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography.Text>
              {t('program.fromDate')}
            </Typography.Text>
            <Typography.Text strong>
              {formatDateDDMMYYYY(data?.projectData?.fromDate, '/')}
            </Typography.Text>
          </Col>
          <Col className="u-mb-8" xs={12} sm={6} style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography.Text>
              {t('program.toDate')}
            </Typography.Text>
            <Typography.Text strong>
              {formatDateDDMMYYYY(data?.projectData?.toDate, '/')}
            </Typography.Text>
          </Col>
          <Col xs={12} sm={6} className="u-mb-8" style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography.Text>
              {t('program.personInChargeAC')}
              {' '}
            </Typography.Text>
            <Typography.Text strong>
              {data?.accountant?.fullname || ''}
            </Typography.Text>
          </Col>
          <Col xs={12} sm={6} className="u-mb-8" style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography.Text>
              {t('program.personInChargeOP')}
              {' '}
            </Typography.Text>
            <Typography.Text strong>
              {data?.operation?.fullname || ''}
            </Typography.Text>
          </Col>
          <Col xs={12} sm={6} className="u-mb-8" style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography.Text>
              {t('program.creatorTableSalary')}
              {' '}
            </Typography.Text>
            <Typography.Text strong>
              {data?.payrollData?.fullname || ''}
            </Typography.Text>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default InfoCard;
